import { useId } from "react";
import { useTranslation } from "react-i18next";

/**
 * "Watch Docker containers" with what it costs: the agent joins the docker
 * group, which is root-equivalent (owner's decision 8: on by default, and
 * the checkbox says so). Used on the create page and in the enable dialog.
 */
export function DockerOption({
  checked,
  onChange,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
}) {
  const { t } = useTranslation();
  const hint = useId();
  return (
    <label className="flex cursor-pointer items-start gap-3 rounded-lg border border-line px-3 py-2.5 text-sm hover:bg-surface-2">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        aria-describedby={hint}
        className="mt-0.5 size-4 shrink-0 accent-accent"
      />
      <span className="flex min-w-0 flex-col gap-0.5">
        <span className="font-medium">{t("autopilot.docker.label")}</span>
        <span id={hint} className="text-muted">
          {t("autopilot.docker.hint")}
        </span>
      </span>
    </label>
  );
}
